import React, { useState, useRef } from "react";
import arrowleft from "../assets/images/arrow-left.png";
import uploadicon from "../assets/images/upload-icon.png";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import { showToast } from "./ShowToast";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function AdManagement() {
  const token = localStorage.getItem("xAuthToken");
  const navigate = useNavigate();

  const inputFileRef = useRef(null);
  const [videoshow, setShowVideo] = useState("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [localSpin, setLocalSpin] = useState(false);
  const [image, setImage] = useState({});
  const [videoDuration, setVideoDuration] = useState(0);
  const [isAdRunStart, setIsAdRunStart] = useState(false);
  const [isAdRunMiddle, setIsAdRunMiddle] = useState(false);
  const [isAdRunEnd, setIsAdRunEnd] = useState(false);
  console.log("duraton in state----", videoDuration);

  const onVideoChange = (event) => {
    let img = event.target.files[0];
    setImage(img);

    const videoToshow = URL.createObjectURL(img);
    setShowVideo(videoToshow);
  };

  const ClearVideo = () => {
    setShowVideo("");
  };

  const handleUpload = () => {
    if (videoDuration > 7) {
      showToast("error", "No upload video maximum 7 second");
    } else {
      if (image.type !== "video/mp4") {
        setError("Invalid file.");
        return;
      } else {
        setError("");
      }

      http
        .post(`api/admin/ad/upload?token=${token}`, {
          file_type: "video/mp4",
          isAdRunStart: isAdRunStart ? 1 : 0,
          isAdRunMiddle: isAdRunMiddle ? 1 : 0,
          isAdRunEnd: isAdRunEnd ? 1 : 0,
        })
        .then((res) => {
          const { url, key } = res.data.data;
          showToast("success", res.data.message);
          setUrl(key);
          setLocalSpin(true);
          fetch(url, {
            body: image,
            method: "PUT",
            headers: {
              "content-type": image.type,
              Accept: "*/*",
            },
          }).then((res) => {
            setLocalSpin(false);
            navigate(-1)
            // showToast("success", res.data.message);
          });
        })
        .catch((error) => {
          setLocalSpin(false);

          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              setError(error.response.data.message);
            }
          }
        });
    }
  };
  const videoEl = useRef(null);

  const handleLoadedMetadata = () => {
    const video = videoEl.current;
    if (!video) return;
    console.log(`The video is ${video.duration} seconds long.`);
    setVideoDuration(video.duration);
    // if (video.duration == 7) {
    //   showToast("success", "No upload video maximum 7 second");
    // } else {
    //   handleUpload();
    // }
  };

  return (
    <>
      <body>
        <div className="wrapper">
          <Nav />
          <div id="content">
            <header>
              <div className="dashboard_header">
                <div className="left-side d-flex ">
                  {" "}
                  {/*   <button
                    type="button"
                    id="sidebarCollapse"
                    className="btn btn-link  "
                  >
                    {" "}
                    <img src={arrowleft} className="img-fluid" />{" "}
                  </button> */}
                  <h1>Ad Management</h1>
                </div>
                <DropdownRight />
              </div>
            </header>
            <div className="dashbord_content Permissions_text">
              <p>Upload your file...</p>
              <p className="mt-5">Upload ad video here</p>

              <div className="fileupload">
                <div className="fileupload-inner">
                  {videoshow ? (
                    <>
                      <video
                        className="upload"
                        src={videoshow}
                        style={{ width: 480 }}
                        controls
                        download
                        ref={videoEl}
                        onLoadedMetadata={handleLoadedMetadata}
                      />{" "}
                    </>
                  ) : (
                    <>
                      <img src={uploadicon} alt="upload-icon" />
                    </>
                  )}
                </div>
                <input
                  className="upload"
                  type="file"
                  name="myfile"
                  ref={inputFileRef}
                  onChange={onVideoChange}
                />
              </div>
              <h6 style={{ color: "red" }}>{error}</h6>
              <div className="ad-options">
                <label>
                  <input
                    type="checkbox"
                    checked={isAdRunStart}
                    onChange={() => setIsAdRunStart(!isAdRunStart)}
                  />
                  Run ad at the start
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={isAdRunMiddle}
                    onChange={() => setIsAdRunMiddle(!isAdRunMiddle)}
                  />
                  Run ad in the middle
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={isAdRunEnd}
                    onChange={() => setIsAdRunEnd(!isAdRunEnd)}
                  />
                  Run ad at the end
                </label>
              </div>
              <div className="col-12 d-flex justify-content-start">
                <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                  <button
                    type="button"
                    className=" them_btn_ouline  "
                    onClick={ClearVideo}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="them_btn "
                    onClick={handleUpload}
                  >
                    {localSpin ? <SpinnerCircular size="20%" /> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
      <ToastContainer />
    </>
  );
}
